/**
 * Controlador global de microfone: garante apenas um ativo por vez.
 * Ao iniciar em outro campo, para o anterior e preserva o texto.
 */

type StopFn = () => void

let activeStop: StopFn | null = null

export function registerActiveMic(stop: StopFn): void {
  if (activeStop) {
    activeStop()
    activeStop = null
  }
  activeStop = stop
}

export function unregisterActiveMic(stop: StopFn): void {
  if (activeStop === stop) {
    activeStop = null
  }
}

export function stopActiveMic(): void {
  if (activeStop) {
    activeStop()
    activeStop = null
  }
}

export function isMicActive(): boolean {
  return activeStop !== null
}
